// extracted by mini-css-extract-plugin
export default {"inputPhone":"kFAk9y3Z8g7sQeNCwHIU","studentId":"JBm9DGIkOFxLRb0HE3FA","hint":"JTWosDIguLtIn2cjt0qG"};